/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlMatterFieldFieldsFragment = {
  __typename: "MatterField";
  name: string;
  type: string;
  possibleValues?: Array<string> | null;
  dataSourceMapping?: string | null;
  displayName?: string | null;
  details?: string | null;
  allowedRepeatable?: boolean | null;
  hint?: string | null;
  supportsCustomValues?: boolean | null;
  originalName?: string | null;
};

export const MatterFieldFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "matterFieldFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MatterField" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "possibleValues" } },
          { kind: "Field", name: { kind: "Name", value: "dataSourceMapping" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "allowedRepeatable" } },
          { kind: "Field", name: { kind: "Name", value: "hint" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "supportsCustomValues" },
          },
          { kind: "Field", name: { kind: "Name", value: "originalName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GqlMatterFieldFieldsFragment, unknown>;
